import { useTranslation } from "react-i18next";
import $ from "jquery";
import SimpleBar from "simplebar-react";

import React, { useState, useEffect, useRef } from "react";

import pic_gruppenpreise from "../../../assets/images/mgsuite/Movements_16x16.png";
import pic_parkhauspreise from "../../../assets/images/mgsuite/Movements_16x16.png";
import pic_parkhauspreise_abweichungen from "../../../assets/images/mgsuite/Movements_16x16.png";

import Gruppenpreise from "./Gruppenpreise";
import Parkhauspreise from "./Parkhauspreise";
import Parkhauspreisabweichungen from "./Parkhauspreisabweichungen";

const CustomLogik_AXAKoeln = (props) => {
  const { t } = useTranslation();
  const activeRights = JSON.parse(localStorage.getItem("rights"));
  const [selectedType, setSelectedType] = useState("gruppenpreise");

  $(".einstellungen-container")
    .css("background-color", "unset")
    .css("color", "unset");
  $("#" + selectedType)
    .css("background-color", "#e9ecef")
    .css("color", "unset");

  function mainView() {
    function renderView() {
      switch (selectedType) {
        case "gruppenpreise":
          return <Gruppenpreise> </Gruppenpreise>;
        case "parkhauspreise":
          return <Parkhauspreise> </Parkhauspreise>;
        case "parkhauspreise_abweichungen":
          return <Parkhauspreisabweichungen> </Parkhauspreisabweichungen>;
      }
    }

    return (
      <div className="left-container-se settings-left">
        <SimpleBar style={{ width: "100%", height: "100%" }}>
          <div
            id="settings-page-view-container"
            style={{
              display: "flex",
              justifyContent: "center",
              width: "100%",
            }}
          >
            {renderView()}
          </div>
        </SimpleBar>
      </div>
    );
  }

  return (
    <div className="pagewrapper-2">
      {mainView()}

      <div className="right-container-se" id="selection">
        <div className="content-name">{t("allgemein.auswahl")}</div>
        <div className="content">
          <div className="content-group">
            <div className="content-group-name">
              {t("allgemein.einstellungen")}
            </div>

            {activeRights.find((item) => item.includes("Gruppenpreise.")) && (
              <div
                className="einstellungen-container"
                onClick={() => setSelectedType("gruppenpreise")}
              >
                <img src={pic_gruppenpreise} className="einstellungen-img" />
                Gruppenpreise
              </div>
            )}

            {activeRights.find((item) => item.includes("Parkhauspreise.")) && (
              <div
                className="einstellungen-container"
                onClick={() => setSelectedType("parkhauspreise")}
              >
                <img src={pic_parkhauspreise} className="einstellungen-img" />
                Parkhauspreise
              </div>
            )}

            {activeRights.find((item) =>
              item.includes("Parkhauspreisabweichungen.")
            ) && (
              <div
                className="einstellungen-container"
                onClick={() => setSelectedType("parkhauspreise_abweichungen")}
              >
                <img
                  src={pic_parkhauspreise_abweichungen}
                  className="einstellungen-img"
                />
                Parkhauspreisabweichungen
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomLogik_AXAKoeln;
